const JsonEncodeInput = () => null;

export default JsonEncodeInput;
